import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import { murmurhash } from '../../lib/js/hash';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ContentCard } from '../../_lib/components/ContentCard';
import { ContentCardName } from '../../_lib/components/ContentCard/partials/ContentCardName';

type AreaGroup = {
  name: string;
};

type OverallAreaGroupsProps = {
  areaGroups: AreaGroup[];
};

function OverallAreaGroups({ areaGroups }: OverallAreaGroupsProps) {
  const { t } = useSonTranslation('AreaGroups');

  if (areaGroups && areaGroups.length > 0) {
    return (
      <div className="overall-area-groups">
        <div className="overall-area-groups__role-group-headline">
          <ContentHeadline title={t('overallAreaGroups.blockTitle')} hierarchy={3} />
        </div>
        <ContentList>
          {areaGroups.map(areaGroup => (
            <ContentListItem key={murmurhash(areaGroup)}>
              <ContentCard>
                <ContentCardName>{areaGroup.name}</ContentCardName>
              </ContentCard>
            </ContentListItem>
          ))}
        </ContentList>
      </div>
    );
  }
  return null;
}

export const OverallAreaGroupsBlock = asBlock(OverallAreaGroups, BlockType.overallareagroups);
export type OverallAreaGroupsBlock = ComponentProps<typeof OverallAreaGroupsBlock>;
